<ng-template #paymentContent>
  <div class="payment-invoice-card">
    <!-- Estado de visualização -->
    <div *ngIf="!isEditing" class="pi-container">
      <div class="pi-payment-item" *ngIf="!isPlanPayment">
        <div class="pi-config-header">
          <div class="pi-config-title">
            <p class="section-title">{{ 'pages.paymentInvoice.seller.title' | i18n }}</p>
            <p class="pi-value">{{ getSellerAssistanceLabel() }}</p>
            <p class="seller-name" *ngIf="sellerAssistance && sellerData?.data?.name">
              {{ 'pages.paymentInvoice.seller.nameLabel' | i18n }} {{ sellerData?.data?.name }}
            </p>
          </div>
          <div class="pi-actions">
            <button type="button" class="pi-edit-btn" (click)="editPayment()">{{ 'pages.paymentInvoice.actions.edit' | i18n }}</button>
          </div>
        </div>
      </div>

      <div class="pi-payment-item" *ngIf="invoicePaymentType === 'boleto_cartao'">
        <div class="pi-divider"></div>
        <div class="pi-config-header">
          <div class="pi-config-title">
            <p class="section-title">{{ 'pages.paymentInvoice.payment.title' | i18n }}</p>
            <p class="pi-value">{{ getPaymentMethodLabel() }}{{ selectedPaymentMethod === 'credit_card' && getSelectedCard() ? ' - ' + (getSelectedCardFlag() === 'UNKNOWN' ? 'Cartão' : (getSelectedCardFlag() | titlecase)) + ' **** ' + getSelectedCard()?.lastFourDigits : '' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado de edição -->
    <div *ngIf="isEditing" class="pi-edit-mode">
      <p class="payment-invoice-card-description" *ngIf="!isPlanPayment">
        {{ 'pages.paymentInvoice.description' | i18n }}
      </p>

      <section class="seller-section" *ngIf="!isPlanPayment">
        <p class="section-title">{{ 'pages.paymentInvoice.seller.title' | i18n }}</p>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              name="salesperson"
              value="true"
              [checked]="sellerAssistance"
              (change)="onSalespersonChange(true)"
              class="radio-input"
            />
            <span class="radio-label">{{ 'pages.paymentInvoice.seller.yes' | i18n }}</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="salesperson"
              value="false"
              [checked]="!sellerAssistance"
              (change)="onSalespersonChange(false)"
              class="radio-input"
            />
            <span class="radio-label">{{ 'pages.paymentInvoice.seller.no' | i18n }}</span>
          </label>
        </div>

        <form [formGroup]="sellerForm" *ngIf="sellerAssistance">
          <div class="input-group">
            <ustore-input
              [placeholder]="'pages.paymentInvoice.seller.codePlaceholder' | i18n"
              formControlName="sellerCode"
              [clearable]="false"
              maxlength="5"
              (input)="onSellerCodeInput($event)"
              (paste)="onSellerCodePaste($event)"
              [disabled]="isLoadingSellerCode"
            ></ustore-input>

            <!-- Loading -->
            <div class="seller-code-status" *ngIf="isLoadingSellerCode">
              <small class="loading-text">{{ 'pages.paymentInvoice.seller.verifying' | i18n }}</small>
            </div>

            <div
              *ngIf="sellerForm.get('sellerCode')?.errors && sellerForm.get('sellerCode')?.touched && !isLoadingSellerCode"
              class="field-error"
            >
              <span *ngIf="sellerForm.get('sellerCode')?.errors?.['required']">{{ 'pages.paymentInvoice.seller.errorRequired' | i18n }}</span>
               <span *ngIf="sellerForm.get('sellerCode')?.errors?.['invalidSeller']">{{ 'pages.paymentInvoice.seller.errorInvalid' | i18n }}</span>
            </div>

            <p class="seller-name success" *ngIf="sellerData?.data?.name && !isLoadingSellerCode">
              {{ 'pages.paymentInvoice.seller.nameLabel' | i18n }} {{ sellerData?.data?.name }}
            </p>
          </div>
        </form>
      </section>

      <section class="payment-section" *ngIf="invoicePaymentType === 'boleto_cartao'">
        <h4 class="section-title">{{ 'pages.paymentInvoice.payment.title' | i18n }}</h4>
        <umkt-slide-button
          *ngIf="!isPlanPayment"
          [options]="paymentMethodOptions"
          [defaultOptionValue]="selectedPaymentMethod"
          (valueChange)="onPaymentMethodChange($event)"
        ></umkt-slide-button>

        <div *ngIf="(selectedPaymentMethod === 'credit_card' || isPlanPayment) && !showCardForm && !hasDSMProducts">
          <umkt-credit-card-list
            [cardsInfo]="cardsInfo"
            (cardSelected)="onCreditCardSelected($event)"
            [selectedCardToken]="selectedCardId"
          ></umkt-credit-card-list>
        </div>

        <form [formGroup]="creditCardForm" *ngIf="showCardForm && !hasDSMProducts" class="new-card-form">
          <p class="section-title">{{ 'pages.paymentInvoice.cardForm.title' | i18n }}</p>
          <umkt-input-credit-card-number 
            formControlName="cardNumber"
            (cardFlagChange)="onCardFlagChange($event)">
          </umkt-input-credit-card-number>

          <div class="input-group">
            <ustore-input
              [placeholder]="'pages.paymentInvoice.cardForm.holderPlaceholder' | i18n"
              formControlName="cardHolder"
              [clearable]="false"
              maxlength="64"
              (input)="onCardNameInput($event)"
              (keydown)="blockLeadingSpace($event)"
            ></ustore-input>

            <div *ngIf="creditCardForm.get('cardHolder')?.errors && creditCardForm.get('cardHolder')?.touched" class="field-error">
              {{ creditCardForm.get('cardHolder') | validationMessage }}
            </div>
          </div>

          <div class="row-group">
            <div class="input-group">
              <ustore-input
                [placeholder]="'pages.paymentInvoice.cardForm.expiryPlaceholder' | i18n"
                formControlName="cardExpirationDate"
                [clearable]="false"
                (input)="onExpiryDateInput($event)"
              ></ustore-input>
              <div *ngIf="creditCardForm.get('cardExpirationDate')?.errors && creditCardForm.get('cardExpirationDate')?.touched" class="field-error">
                {{ creditCardForm.get('cardExpirationDate') | validationMessage }}
              </div>
            </div>

            <div class="input-group">
              <ustore-input
                [placeholder]="'pages.paymentInvoice.cardForm.cvcPlaceholder' | i18n"
                formControlName="cardSecurityCode"
                [clearable]="false"
                maxlength="4"
                (input)="onCvcInput($event)"
              ></ustore-input>
              <div *ngIf="creditCardForm.get('cardSecurityCode')?.errors && creditCardForm.get('cardSecurityCode')?.touched" class="field-error">
                {{ creditCardForm.get('cardSecurityCode') | validationMessage }}
              </div>
            </div>
          </div>

          <div class="input-group">
            <ustore-input
              [placeholder]="'pages.paymentInvoice.cardForm.cnpjPlaceholder' | i18n"
              formControlName="document"
              [clearable]="false"
              maxlength="18"
              (input)="onCnpjInput($event)"
              (paste)="onCnpjPaste($event)"
            ></ustore-input>

            <div *ngIf="creditCardForm.get('document')?.errors?.['invalidCNPJ'] && creditCardForm.get('document')?.touched" class="field-error">
              {{ 'pages.paymentInvoice.cardForm.errorCNPJ' | i18n }}
            </div>
          </div>

          <div class="button-group">
            <button type="button" class="btn-outline" (click)="onCancelCard()">{{ 'shared.buttons.cancel' | i18n }}</button>
            <button type="button" class="btn-primary" (click)="onRegisterCard()" [disabled]="!creditCardForm.valid">
              {{ (isPlanPayment ? 'pages.paymentInvoice.cardForm.registerButton' : 'pages.paymentInvoice.cardForm.registerUseButton') | i18n }}
            </button>
          </div>
        </form>
      </section>
    </div>

    <!-- Ações quando em modo de visualização -->
    <div class="payment-card-actions" *ngIf="isEditing && !showCardForm">
      <button 
        class="btn-outline" 
        *ngIf="isLastStep; else backButton"
        (click)="cancelEdit()">
        {{ 'shared.buttons.cancel' | i18n }}
      </button>
      <ng-template #backButton>
        <button class="btn-outline" (click)="previousStep.emit()">{{ 'shared.buttons.back' | i18n }}</button>
      </ng-template>
      <button class="btn-primary" (click)="saveAndContinue()" [disabled]="!showCheck">
        {{ (isLastStep ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
      </button>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!isPlanPayment; else contentOnly">
  <umkt-card-wrapper
    [title]="'pages.paymentInvoice.title' | i18n"
    [icon]="{ name: 'pagamento-digital', type: 'mondrian-icons' }"
    [showCheck]="showCheck"
    [loading]="isLoading"
    [loadingText]="'shared.messages.processing' | i18n"
    [initiallyOpen]="initiallyOpen"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="paymentContent"></ng-container>
  </umkt-card-wrapper>
</ng-container>

<ng-template #contentOnly>
  <ng-container *ngTemplateOutlet="paymentContent"></ng-container>
  <umkt-loading [isLoading]="isLoading"></umkt-loading>
</ng-template>